import React, { Component } from "react";
import "./loader.scss";
import ReactLoading from "react-loading";

class Loader extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="loader-container centered">
        <div className="spinner">
          <ReactLoading
            type={"spinningBubbles"}
            color={"#979797"}
            height={58}
            width={56}
          />
        </div>

        <label className="loader-msg">{this.props.message}</label>
      </div>
    );
  }
}
export default Loader;
